// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: "Fira Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f5f6;
}

code {
  font-family: "Fira Sans", sans-serif;
}

*:focus {
  outline: none;
}

textarea::placeholder {
  color: #b4b2b2d2;
}
/***/
.marker {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  align-items: center;
  /* width: 150px; */
}

.marker-text {
  font-weight: 600;
}
.scroll-invisible {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scroll-invisible::-webkit-scrollbar {
  display: none;
}

/** */
.tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #f39325 transparent transparent transparent;
}

input[type="number"] {
  margin: 0;
}

/* Remove scroll from the number input */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;AACA,IAAI;AACJ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;AACA;EACE,aAAa;AACf;;AAEA,KAAK;AACL;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,SAAS;AACX;;AAEA,wCAAwC;AACxC;;EAEE,8CAA8C;EAC9C,wBAAwB;EACxB,SAAS,EAAE,uEAAuE;AACpF;;AAEA;EACE,0BAA0B,EAAE,YAAY;AAC1C","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  font-family: \"Fira Sans\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #f5f5f6;\n}\n\ncode {\n  font-family: \"Fira Sans\", sans-serif;\n}\n\n*:focus {\n  outline: none;\n}\n\ntextarea::placeholder {\n  color: #b4b2b2d2;\n}\n/***/\n.marker {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  justify-content: center;\n  align-items: center;\n  /* width: 150px; */\n}\n\n.marker-text {\n  font-weight: 600;\n}\n.scroll-invisible {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n.scroll-invisible::-webkit-scrollbar {\n  display: none;\n}\n\n/** */\n.tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #f39325 transparent transparent transparent;\n}\n\ninput[type=\"number\"] {\n  margin: 0;\n}\n\n/* Remove scroll from the number input */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  /* display: none; <- Crashes Chrome on hover */\n  -webkit-appearance: none;\n  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield; /* Firefox */\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
